// app/javascript/controllers/acc_user_infractions_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  addInfraction(event) {
    event.preventDefault()
    let content = this.templateTarget.innerHTML
    this.containerTarget.insertAdjacentHTML('beforeend', content)
  }

  removeInfraction(event) {
    event.preventDefault()
    if (confirm("Are you sure you want to delete this infraction/merit entry?")) {
      event.target.closest(".infraction-fields").remove()
    }
  }
}

